import { render, staticRenderFns } from "./CustomColorPicker.vue?vue&type=template&id=13c8a29f&scoped=true"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomColorPicker.vue?vue&type=style&index=0&id=13c8a29f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8a29f",
  null
  
)

export default component.exports